import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HeaderbarComponent } from './components/shared/headerbar/headerbar.component';
import { SliderComponent } from './components/shared/slider/slider.component';
import { NewsComponent } from './components/shared/news/news.component';

import { FeatureComponent } from './components/shared/feature/feature.component';

import { SpatialdashComponent } from './components/shared/spatialdash/spatialdash.component';

import { LinksComponent } from './components/shared/links/links.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { AcknowledComponent } from './components/shared/acknowled/acknowled.component';
import { ExpressionComponent } from './components/shared/expression/expression.component';
import { EventsComponent } from './components//events/events.component';
import { CoursesComponent } from './components/courses/courses.component';
import { ProjectsComponent } from './components/projects/projects.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { PatentsComponent } from './components/patents/patents.component';
import { ContactComponent } from './components/contact/contact.component';
import { CarrersComponent } from './components/carrers/carrers.component';

import { GalleryPhotoComponent } from './components/gallery/gallery-photo/gallery-photo.component';
import { MedicalComponent } from './components/research/medical/medical.component';
import { InnovationComponent } from './components/research/innovation/innovation.component';
import { HumanFaComponent } from './components/research/human-fa/human-fa.component';

import { BehaviourComponent } from './components/research/behaviour/behaviour.component';
import { PublicpolicyComponent } from './components/research/publicpolicy/publicpolicy.component';
// import { HumanFaComponent } from './components/research/human-fa/human-fa.component';


import { PeopleComponent } from './components/people/people.component';
import { AboutComponent } from './components/about/about.component';
import { AboutSingleComponent } from './components/about-single/about-single.component';
import { PreloadComponent } from './components/preload/preload.component';
import { DataProviderService } from './service/data-provider.service';
import { HwweComponent } from './components/events/hwwe/hwwe.component';
// import { AppRoutingModule } from './app.routing.module';
import { RouterModule, Routes } from '@angular/router';
import { SingleComponent } from './components/single/single.component';
import { HomeComponent } from './components/home/home.component';
import { MainproComponent } from './components/mainpro/mainpro.component';
import { SubprojectsComponent } from './components/subprojects/subprojects.component';
import { VbsirComponent } from './components/shared/vbsir/vbsir.component';
import { SlideshowModule } from 'ng-simple-slideshow';
import { HprojectsComponent } from './components/shared/hprojects/hprojects.component';
import { AwardComponent } from './components/shared/award/award.component';
import { AchivementsComponent } from './components/achivements/achivements.component';
import { ComponentsComponent } from './components/components.component';
import { UpdateComponent } from './components/update/update.component';
import { BlogComponent } from './components/blog/blog.component';
import { CoehfssComponent } from './components/coehfss/coehfss.component';
import { TeammemberComponent } from './components/profile/teammember/teammember.component';
import { TeamknowmoreComponent } from './components/profile/teamknowmore/teamknowmore.component';
import { AlumniComponent } from './components/profile/alumni/alumni.component';
import { MissionvissionComponent } from './components/rbg/missionvission/missionvission.component';
import { CollaboratorsComponent } from './components/profile/collaborators/collaborators.component';
import { WorkshopComponent } from './workshop/workshop.component';
import { DriverComponentComponent } from './driver-component/driver-component.component';
import { DrivertrainingComponent } from './drivertraining/drivertraining.component';
import { SanjayavideoComponent } from './components/sanjayavideo/sanjayavideo.component';






const appRoutes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'eventsInfo/:id',
    component: HwweComponent
  },
  {
    path: 'gallery',
    component: GalleryComponent
  },
  {
    path: 'galleryDetail',
    component: GalleryPhotoComponent
  },
  {
    path: 'courses',
    component: CoursesComponent
  },
  {
    path: 'patent',
    component: PatentsComponent
  },
  {
    path: 'careers',
    component: CarrersComponent
  },
  {
    path: 'update',
    component: UpdateComponent
  },
  {
    path: 'project',
    component: MainproComponent
  },
  {
    path: 'events',
    component: EventsComponent
  },
  {
    path: 'eventsInfo/:eventNo',
    component: HwweComponent
  },
  {
    path: 'human',
    component: HumanFaComponent
  },
  {
    path: 'innovation',
    component: InnovationComponent
  },
  {
    path: 'medical',
    component: MedicalComponent
  },
  {
    path: 'publicPolicy',
    component: PublicpolicyComponent
  },
  {
    path: 'driverFatigue',
    component: BehaviourComponent
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'people',
    component: PeopleComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'newsInfo/:id',
    component: SingleComponent
  },
  {
    path: 'profile/:id',
    component: AboutSingleComponent
  },
  {
    path: 'viewprofile/:id',
    component: TeamknowmoreComponent
  },
  {
    path: 'summary',
    component: ProjectsComponent
  },
  {
    path: 'mainproInfo/:projectNo',
    component: SubprojectsComponent
  },
  {
    path: 'newsAward/:id',
    component: AchivementsComponent
  },
  {
    path: 'blog',
    component: BlogComponent
  },
  {
    path: 'alumni',
    component: AlumniComponent
  },
  {
    path: 'teams',
    component: TeammemberComponent
  },
  {
    path: 'Collaborators',
    component: CollaboratorsComponent
  },
   {
    path: 'TN_RTI_Dashboard',
    component: FeatureComponent
  },

{
    path: 'TN_Spatial_Dashboard',
    component: SpatialdashComponent
  },
  {
    path: 'CoEHfSS',
    component: CoehfssComponent
  },
  {
    path: 'WS/12102021',
    component: WorkshopComponent
  },
  {
    path: 'Driver_Training',
    component: DrivertrainingComponent
  },
  {
    path: 'Sanjaya_Introduction',
    component: SanjayavideoComponent
  },

  

];
@NgModule({
  declarations: [
    AppComponent,
    HeaderbarComponent,
    SliderComponent,
    FeatureComponent,
    SpatialdashComponent,
    CoehfssComponent,
    LinksComponent,
    FooterComponent,
    AcknowledComponent,
    ExpressionComponent,
    EventsComponent,
    NewsComponent,
    CoursesComponent,
    ProjectsComponent,
    GalleryComponent,
    PatentsComponent,
    ContactComponent,
    GalleryPhotoComponent,
    MedicalComponent,
    InnovationComponent,
    HumanFaComponent,
    PeopleComponent,
    AboutComponent,
    AboutSingleComponent,
    PreloadComponent,
    HwweComponent,
    SingleComponent,
    HomeComponent,
    MainproComponent,
    SubprojectsComponent,
    VbsirComponent,
    HprojectsComponent,
    AwardComponent,
    AchivementsComponent,
    ComponentsComponent,
    UpdateComponent,
    BehaviourComponent,
    PublicpolicyComponent,
    CarrersComponent,
    BlogComponent,
    TeammemberComponent,
    TeamknowmoreComponent,
    AlumniComponent,
    MissionvissionComponent,
    CollaboratorsComponent,
    WorkshopComponent,
    DrivertrainingComponent,
    SanjayavideoComponent
    


  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SlideshowModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false, useHash: true })
  ],
  providers: [DataProviderService],
  bootstrap: [AppComponent]
})
export class AppModule { }
